<clr-modal [(clrModalOpen)]="modalOpen" [clrModalSize]="'xl'" [clrModalClosable]="true" id="messunggrenzwert">
  <h3 class="modal-title" style="display: flex; margin-left: 15px">{{ title | mrTranslate }}</h3>

  <div class="modal-body">
    @if (grenzwerte?.columns) {
      <div>
        @if (selected) {
          <div>
            <div class="form-group" style="margin-top: 0px; margin-left: 10px; max-height: 40px">
              <div class="btn-group btn-sm btn-icon">
                <button
                  class="btn btn-success"
                  [disabled]="selected?.length == 0"
                  (click)="deleteResetTolVer(selected)">
                  <clr-tooltip>
                    <cds-icon clrTooltipTrigger shape="check" />
                    <clr-tooltip-content [clrPosition]="'top-right'" [clrSize]="'md'">
                      {{ 'Messwerte korrigieren' | mrTranslate }}
                    </clr-tooltip-content>
                  </clr-tooltip>
                </button>
                <button class="btn btn-danger" [disabled]="selected?.length == 0" (click)="deleteItemsTolVer(selected)">
                  <clr-tooltip>
                    <cds-icon clrTooltipTrigger shape="times" />
                    <clr-tooltip-content [clrPosition]="'top-right'" [clrSize]="'md'">
                      {{ 'Eintrag löschen' | mrTranslate }}
                    </clr-tooltip-content>
                  </clr-tooltip>
                </button>
              </div>
            </div>
          </div>
        }
        <div class="limit-height-1">
          @if (grenzwerte?.columns) {
            <clr-datagrid
              style="padding-top: 0px"
              [clrDgSelectionType]="'single'"
              [clrDgSelected]="[selected]"
              (clrDgSelectedChange)="selected = $event[0]"
              [clrDgRowSelection]="true">
              @for (column of grenzwerte.columns; track column) {
                <clr-dg-column [clrDgField]="column.id">
                  <ng-container
                    *clrDgHideableColumn="{
                      hidden: column.id | hideIDColumns: ['typ', 'Profiltyp', 'SchHMax', 'BildBase64', 'Profil'],
                    }">
                    {{ column.id | mrTranslate | titlecase }}
                  </ng-container>
                </clr-dg-column>
              }

              <clr-dg-row *clrDgItems="let row of grenzwerte.rows" [clrDgItem]="row">
                @for (cell of grenzwerte.columns; track cell) {
                  <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                }
              </clr-dg-row>
              <ng-template clrIfDetail let-detail (clrIfDetailChange)="onDetailOpenGernzwert($event)">
                <clr-dg-detail>
                  <clr-dg-detail-header style="margin-top: -15px">
                    {{ 'Messnr.' | mrTranslate }}: {{ detail['Messnr.'] }}
                  </clr-dg-detail-header>
                  <clr-dg-detail-body>
                    <table class="table" style="margin-top: 0px">
                      <tr>
                        <th>{{ 'Objekt' | mrTranslate }}</th>
                        <th>{{ 'Wert' | mrTranslate }}</th>
                      </tr>
                      @for (data of grenzwerteitems; track data) {
                        <tr>
                          @if (data['object'] !== 'Instandsetzung') {
                            <td style="padding: 5px 5px 5px 0">{{ data['object'] }}</td>
                            <td style="padding: 5px 5px 5px 0">{{ data['wert'] }}</td>
                          }
                          <!-- @else {
                          <td>{{data["object"]}}</td>
                          <td>
                            <input clrInput value={{data.wert}} style="min-width: 300px;" />
                          </td>
                          } -->
                        </tr>
                      }
                    </table>
                    <form clrForm [formGroup]="verl">
                      <clr-input-container style="margin-top: 15px">
                        <label>{{ 'Instandsetzung' | mrTranslate }}</label>
                        <input clrInput formControlName="ih" style="min-width: 550px" />
                      </clr-input-container>
                      <div class="clr-row" style="margin-top: 0px">
                        <div class="clr-col-3">
                          <button class="btn btn-primary btn-sm" type="submit" (click)="saveItemsVerl()">
                            {{ 'Speichern' | mrTranslate }}
                          </button>
                        </div>
                      </div>
                    </form>
                  </clr-dg-detail-body>
                </clr-dg-detail>
              </ng-template>
              <clr-dg-footer>{{ grenzwerte?.rows?.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
            </clr-datagrid>
          }
        </div>
        <div class="clr-row" style="margin-top: 0px; margin-left: 5px; max-height: 40px">
          <form clrForm [formGroup]="verl">
            <clr-checkbox-container>
              <clr-checkbox-wrapper>
                <label>{{ 'alte Messwertverletzungen löschen' | mrTranslate }}</label>
                <input type="checkbox" clrCheckbox formControlName="deleteold" />
              </clr-checkbox-wrapper>
            </clr-checkbox-container>
          </form>
        </div>
      </div>
    } @else {
      <form clrForm [formGroup]="inGroup">
        <div class="clr-row" style="margin-top: 5px; margin-left: 10px">
          <div class="clr-col-3" style="padding-left: 5px">
            <span>{{ 'Auswahl Zeitraum' | mrTranslate }}:</span>
          </div>
          <div class="clr-col-2">
            <input
              type="date"
              name="date1"
              clrDate
              [ngModel]="von | localeDate"
              (ngModelChange)="von = localeDate.tosql($event)"
              [ngModelOptions]="{ standalone: true, updateOn: 'blur' }"
              aria-hidden="true" />
          </div>
          <div class="clr-col-2">
            <input
              type="date"
              name="date1"
              clrDate
              [ngModel]="bis | localeDate"
              (ngModelChange)="bis = localeDate.tosql($event)"
              [ngModelOptions]="{ standalone: true, updateOn: 'blur' }"
              aria-hidden="true" />
          </div>
        </div>
        <div class="clr-row" style="margin-top: 20px; margin-left: 10px">
          <div class="clr-col-3" style="padding-left: 5px">
            <span>{{ 'Ausschluss Spurverletzungen' | mrTranslate }}:</span>
          </div>
          <div class="clr-col-9">
            <clr-radio-container clrInline style="margin-top: 10px">
              <clr-radio-wrapper>
                <input type="radio" clrRadio formControlName="ohneweiche" [value]="0" />
                <label>{{ 'Spurverletzungen im Bereich von Weichen ausschließen' | mrTranslate }}</label>
              </clr-radio-wrapper>
              <clr-radio-wrapper>
                <input type="radio" clrRadio formControlName="ohneweiche" [value]="1" />
                <label>{{ 'Spurverletzungen beibehalten' }}</label>
              </clr-radio-wrapper>
            </clr-radio-container>
          </div>
        </div>
        <div class="clr-row" style="margin-top: 10px; margin-left: 10px">
          <div class="clr-col-3" style="padding-left: 5px">
            <span>{{ 'Mängel zusammenfassen' | mrTranslate }}:</span>
          </div>
          <div class="clr-col-1">
            <input type="number" class="clr-input" formControlName="laenge" style="max-width: 80px" />
          </div>
          <div class="clr-col-1">
            <span style="margin-top: 10px; margin-left: -10px">{{ 'm' | mrTranslate }}</span>
          </div>
        </div>
        <div class="clr-row" style="margin-top: 20px; margin-left: 10px">
          <div class="clr-col-3" style="padding-left: 5px">
            <span>{{ 'Toleranzen' | mrTranslate }}:</span>
          </div>
          <div class="clr-col-2">
            <clr-checkbox-container style="margin-top: 10px">
              <clr-checkbox-wrapper>
                <label>{{ 'SRG' | mrTranslate }}</label>
                <input type="checkbox" clrCheckbox formControlName="srg" />
              </clr-checkbox-wrapper>
            </clr-checkbox-container>
          </div>
          <div class="clr-col-2">
            <clr-checkbox-container style="margin-top: 10px">
              <clr-checkbox-wrapper>
                <label>{{ 'SR lim' | mrTranslate }}</label>
                <input type="checkbox" clrCheckbox formControlName="srl" />
              </clr-checkbox-wrapper>
            </clr-checkbox-container>
          </div>
          <div class="clr-col-2">
            <clr-checkbox-container style="margin-top: 10px">
              <clr-checkbox-wrapper>
                <label>{{ 'SR 100' | mrTranslate }}</label>
                <input type="checkbox" clrCheckbox formControlName="sr1" />
              </clr-checkbox-wrapper>
            </clr-checkbox-container>
          </div>
          <div class="clr-col"></div>
          <div class="clr-col-1">
            <div class="btn-group btn-sm btn-icon">
              <button class="btn btn-success" (click)="addItemsMessTol()">
                <cds-icon shape="plus" />
                <span class="clr-icon-title">{{ 'Neu' | mrTranslate }}</span>
              </button>
              <button class="btn btn-danger" [disabled]="selTolID == 0" (click)="deleteItemsMessTol()">
                <cds-icon shape="times" />
                <span class="clr-icon-title">{{ 'Löschen' | mrTranslate }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="limit-height">
          @if (tolradius?.columns) {
            <clr-datagrid style="padding-top: 0px" [clrDgSelectionType]="'multi'" [(clrDgSelected)]="selected">
              @for (column of tolradius.columns; track column) {
                <clr-dg-column [clrDgField]="column.id">
                  <ng-container
                    *clrDgHideableColumn="{
                      hidden: column.id | hideIDColumns: ['typ', 'Profiltyp', 'SchHMax', 'BildBase64', 'Profil'],
                    }">
                    {{ column.id | mrTranslate | titlecase }}
                  </ng-container>
                </clr-dg-column>
              }
              <clr-dg-row *clrDgItems="let row of tolradius.rows" [clrDgItem]="row">
                @for (cell of tolradius.columns; track cell) {
                  <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                }
              </clr-dg-row>
              <ng-template clrIfDetail let-detail (clrIfDetailChange)="onDetailOpenMessTol($event)">
                <clr-dg-detail>
                  <clr-dg-detail-header>{{ detail['bezeichnung'] }}</clr-dg-detail-header>
                  <clr-dg-detail-body>
                    <form clrForm [formGroup]="tolrad">
                      <div class="clr-row">
                        <div class="clr-col-3">
                          {{ 'Messart' | mrTranslate }}
                        </div>
                        <div class="clr-col-3">
                          <clr-select-container style="margin-left: -10px">
                            <select
                              class="bedingungen"
                              clrSelect
                              name="options"
                              #mySelect
                              (change)="onOptionsSelectedMessart(mySelect.value)"
                              formControlName="messart"
                              style="min-width: 160px">
                              <option value="Spurweite">{{ 'Spurweite' | mrTranslate }}</option>
                              <option value="Verwindung">{{ 'Verwindung' | mrTranslate }}</option>
                              <option value="Rillentiefe">{{ 'Rillentiefe' | mrTranslate }}</option>
                              <option value="Überhöhung">{{ 'Überhöhung' | mrTranslate }}</option>
                            </select>
                          </clr-select-container>
                        </div>
                      </div>
                      <div class="clr-row" style="margin-top: 15px">
                        <div class="clr-col-3">
                          {{ 'Bedingung' | mrTranslate }}
                        </div>
                        <div class="clr-col-3">
                          <clr-select-container style="margin-left: -10px">
                            <select
                              class="bedingungen"
                              clrSelect
                              name="options"
                              #mySelect
                              (change)="onOptionsSelectedBedingung(mySelect.value)"
                              formControlName="bed"
                              style="min-width: 160px">
                              <option value=""></option>
                              <option value="Radius">{{ 'Radius' | mrTranslate }}</option>
                            </select>
                          </clr-select-container>
                        </div>
                      </div>
                      <div class="clr-row" style="margin-top: 15px">
                        <div class="clr-col-3">
                          {{ ('Bedingung' | mrTranslate) + ' ' + ('min' | mrTranslate) }}
                        </div>
                        <div class="clr-col-3">
                          <input type="number" class="clr-input" formControlName="bedmin" />
                        </div>
                      </div>
                      <div class="clr-row" style="margin-top: 15px">
                        <div class="clr-col-3">
                          {{ ('Bedingung' | mrTranslate) + ' ' + ('max' | mrTranslate) }}
                        </div>
                        <div class="clr-col-3">
                          <input type="number" class="clr-input" formControlName="bedmax" />
                        </div>
                      </div>
                      <div class="clr-row" style="margin-top: 15px">
                        <div class="clr-col-3">
                          {{ 'Sollwert' | mrTranslate }}
                        </div>
                        <div class="clr-col-3">
                          <input type="number" class="clr-input" formControlName="soll" />
                        </div>
                      </div>
                      <!-- <br> -->
                      <div class="clr-row" style="margin-top: 15px">
                        <div class="clr-col-3">
                          {{ 'SRG -' | mrTranslate }}
                        </div>
                        <div class="clr-col-3">
                          <input type="number" class="clr-input" formControlName="srgm" />
                        </div>
                      </div>
                      <!-- <br> -->
                      <div class="clr-row" style="margin-top: 15px">
                        <div class="clr-col-3">
                          {{ 'SRG +' | mrTranslate }}
                        </div>
                        <div class="clr-col-3">
                          <input type="number" class="clr-input" formControlName="srgp" />
                        </div>
                      </div>
                      <div class="clr-row" style="margin-top: 15px">
                        <div class="clr-col-3">
                          {{ 'SRlim -' }}
                        </div>
                        <div class="clr-col-3">
                          <input type="number" class="clr-input" formControlName="srlm" />
                        </div>
                      </div>
                      <!-- <br> -->
                      <div class="clr-row" style="margin-top: 15px">
                        <div class="clr-col-3">
                          {{ 'SRlim +' }}
                        </div>
                        <div class="clr-col-3">
                          <input type="number" class="clr-input" formControlName="srlp" />
                        </div>
                      </div>
                      <div class="clr-row" style="margin-top: 15px">
                        <div class="clr-col-3">
                          {{ 'SR100 -' }}
                        </div>
                        <div class="clr-col-3">
                          <input type="number" class="clr-input" formControlName="sr1m" />
                        </div>
                      </div>
                      <!-- <br> -->
                      <div class="clr-row" style="margin-top: 15px">
                        <div class="clr-col-3">
                          {{ 'SR100 +' }}
                        </div>
                        <div class="clr-col-3">
                          <input type="number" class="clr-input" formControlName="sr1p" />
                        </div>
                      </div>
                      <!-- <br> -->
                      <div class="clr-row" style="margin-top: 20px">
                        <div class="clr-col-3">
                          <button class="btn btn-primary btn-sm" type="submit" (click)="saveItemsMessTol(detail.ID)">
                            {{ 'Speichern' | mrTranslate }}
                          </button>
                        </div>
                      </div>
                    </form>
                  </clr-dg-detail-body>
                </clr-dg-detail>
              </ng-template>
              <clr-dg-footer>{{ tolradius.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
            </clr-datagrid>
          }
        </div>
        <div class="clr-row" style="margin-top: 15px">
          <div class="clr-col-3">
            <span>{{ 'Anzahl Prüfungen' | mrTranslate }}: {{ countobjekte }}</span>
          </div>
          @if (uploadprocessrun == true) {
            <div class="clr-col-3" style="padding-left: 5px">
              <span>{{ spinnertitel }}</span>
            </div>
          }
        </div>
      </form>
    }
  </div>
  <div class="modal-footer">
    @if (grenzwerte?.rows) {
      <div>
        @if (uploadprocessrun == true) {
          <clr-progress-bar
            [clrValue]="processprogress"
            clrLabeled
            style="margin-top: 10px; width: 75%"></clr-progress-bar>
        }
        @if (uploadprocessrun == false) {
          <button type="button" class="btn" (click)="onExportExcel()">{{ 'Excel' | mrTranslate }}</button>
          <button style="margin-left: 12px" type="button" class="btn" (click)="onImport()">
            {{ 'Einlesen' | mrTranslate }}
          </button>
        }
      </div>
    } @else {
      @if (uploadprocessrun == true) {
        <clr-progress-bar
          [clrValue]="processprogress"
          clrLabeled
          style="margin-top: 10px; width: 75%"></clr-progress-bar>
      }
      @if (opruefids.length != 0) {
        <button type="button" class="btn" (click)="onExport()">{{ 'Start' | mrTranslate }}</button>
      }
    }
    <button type="button" class="btn" (click)="onOK.emit(false)">{{ 'Beenden' | mrTranslate }}</button>
  </div>
</clr-modal>
